import { createApp } from 'vue';
import dJSON from 'dirty-json';
import module from './module.vue';

// mount selector
const moduleSelector = '.module-catboxes';

/**
 * Vue.js Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules) return;

  modules.forEach((query) => {
    try {
      const title = query.title_name;
      const data = dJSON.parse(query.data);

      // vue components init
      createApp(module, {
        title,
        data,
      }).mount(query);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
